export default __webpack_public_path__ + "static/media/icon_inventory.0b2e8ff7.svg";